const getTenderCopy = {
  TenderID: '',
  isactive: true,
  isapproved: true,
};
export default getTenderCopy;
